import { FC, useEffect, ReactNode } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { AppDispatch, RootState } from '../store'
import { validateToken } from '../store/slices/authSlice'

interface AuthProviderProps {
  children: ReactNode
}

const AuthProvider: FC<AuthProviderProps> = ({ children }) => {
  const dispatch = useDispatch<AppDispatch>()
  const { token, isAuthenticated, isLoading } = useSelector((state: RootState) => state.auth)

  useEffect(() => {
    // Validate token on app startup if one exists
    if (token && !isAuthenticated && !isLoading) {
      dispatch(validateToken())
    }
  }, [dispatch, token, isAuthenticated, isLoading])

  return <>{children}</>
}

export default AuthProvider
